import type { IRequestOptionsEvents, IResponseEvent } from "./event.types";
import Event from "./event.model";
import useRequest from "~/hooks/use-request";

export interface IRequestUserMediasOptions extends IRequestPaginatedOptions {
  type: "clips" | "highlight";
  filters?: TSportType[];
}

export interface IRequestOptionsUserClip {
  name?: string;
  targetId: string;
  url: string;
  startTime: number;
  endTime: number;
  streamName: string;
}

const UserMediaEventsAPI = {
  load(options: IRequestOptionsEvents & { user_media_type: "clips" | "highlight" }): Promise<IPaginatedResponse<IModelEvent>> {
    const params = Event.params(options);
    const { request } = useRequest();

    // TODO: Use helper to clean empty params & serialize object params for queries
    params.filters = undefined;

    if (options.eventId)
      params["filters[event_id]"] = options.eventId;

    return request
      .get<IPaginatedResponse<IResponseEvent>>(`/api/user/get_user_${options.user_media_type}`, { query: params, setAuthorization: true })
      .then(Event.formatPaginated);
  },

  loadGameHighlights(options: IRequestOptionsEvents): Promise<IPaginatedResponse<IModelEvent>> {
    const params = Event.params(options);
    const { request } = useRequest();

    return request
      .post<IPaginatedResponse<IResponseEvent>>("/api/vod/list", { body: params, setAuthorization: true })
      .then(Event.formatPaginated);
  },

  async createUserClip(options: IRequestOptionsUserClip) {
    const { request } = useRequest();

    return request
      .post<IResponseUserMedia>("/api/clip/create", { body: options, setAuthorization: true });
  },

  delete(mediaIds: string[]): Promise<string[]> {
    const { request } = useRequest();
    const params = { ids: mediaIds };

    return request
      .post<IResponseUserMedia>("/api/user/delete_user_media", { body: params, setAuthorization: true })
      .then(response => response.content.ids);
  },
};

export default UserMediaEventsAPI;
